import { chain, find, includes, intersectionBy, isUndefined } from 'lodash';
import {
  AvailableCuisineCategoryFragment,
  HierarchicalAvailableCuisineCategoryFragment,
} from 'src/gqlReactTypings.generated.d';

export const getRootCuisineCategories = (cuisinesAndSubcuisines: HierarchicalAvailableCuisineCategoryFragment[]) =>
  cuisinesAndSubcuisines.filter((c) => c.isPrimary);

export const getRootCuisineForCuisine = (
  selectedCuisine: HierarchicalAvailableCuisineCategoryFragment | undefined
): AvailableCuisineCategoryFragment | undefined =>
  selectedCuisine?.isPrimary ? selectedCuisine : find(selectedCuisine?.ancestorCuisines, 'isPrimary');

export const getSubcuisinesForCuisine = (
  rootCuisine: AvailableCuisineCategoryFragment | undefined,
  availableCuisineCategories: HierarchicalAvailableCuisineCategoryFragment[]
): AvailableCuisineCategoryFragment[] => {
  const hierarchicalRootCuisine = find(availableCuisineCategories, { id: rootCuisine?.id });
  return hierarchicalRootCuisine
    ? intersectionBy(availableCuisineCategories, hierarchicalRootCuisine.subcuisines, 'id')
    : [];
};

export const formatCuisines = (
  selectedCuisine: HierarchicalAvailableCuisineCategoryFragment | undefined,
  rootCuisine: AvailableCuisineCategoryFragment | undefined,
  availableCuisineCategories: HierarchicalAvailableCuisineCategoryFragment[]
) =>
  chain(availableCuisineCategories)
    .filter('isPrimary')
    .map(({ id, title }) => ({
      cuisineFilter: id,
      rootCuisineFilter: id,
      title,
      isSelected: includes([selectedCuisine?.id, rootCuisine?.id], id),
    }))
    .value();

export const formatSubcuisines = (
  selectedCuisineId: string | undefined,
  rootCuisine: AvailableCuisineCategoryFragment | undefined,
  subCuisines: AvailableCuisineCategoryFragment[]
) =>
  subCuisines.map(({ id, title }) => ({
    cuisineFilter: id,
    rootCuisineFilter: rootCuisine?.id,
    title,
    isSelected: selectedCuisineId === id,
  }));

export const isSubCuisine = (
  cuisineCategory: HierarchicalAvailableCuisineCategoryFragment | undefined,
  rootCuisine: AvailableCuisineCategoryFragment | undefined
) => !isUndefined(rootCuisine) && cuisineCategory?.id !== rootCuisine?.id;
